"use client"

import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import { motion, AnimatePresence } from "framer-motion"
import { Clock, Trophy, MapPin, ShoppingCart, Calendar, Info, X, ChevronRight, Eye } from "lucide-react"
import "../styles/detalhesEvento.css"
import MapaCategoriaVisual from "../components/MapaCategoriaVisual"

const DetalhesEvento = () => {
  const { id } = useParams()
  const navigate = useNavigate()
  const [evento, setEvento] = useState(null)
  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null)
  const [tempoRestante, setTempoRestante] = useState({ dias: 0, horas: 0, minutos: 0, segundos: 0 })
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)
  const [showMapaCategoria, setShowMapaCategoria] = useState(false)


  useEffect(() => {
    setLoading(true)
    axios
      .get(`https://api.ticketdovaqueiro.com/api/events/${id}`)
      .then((response) => {
      setEvento(response.data);
      setCategoriaSelecionada(response.data.categorias[0] || null);


        const dataBase = response.data.status === "em breve" ? response.data.dataInicio : response.data.dataFim
        calcularTempoRestante(response.data); // 🔁 agora recebe o objeto evento inteiro   
        setLoading(false)
      })
      .catch((error) => {
        console.error("Erro ao buscar evento:", error)
        setLoading(false)
      })
  }, [id])
  // 💡 MÁGICA DO RASTREIO DE AFILIADO (OLHEIRO)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const refCodigo = params.get("ref");
    if (refCodigo) {
      localStorage.setItem("evento_afiliado_ref", refCodigo);
      console.log("🔗 Promotor capturado:", refCodigo);
    }
  }, []);
  // Função para calcular tempo restante
  const calcularTempoRestante = (evento) => {
    let statusAtual = evento.status;
    let targetDate =
      statusAtual === "em breve"
        ? new Date(evento.dataInicio).getTime()
        : new Date(evento.dataFim).getTime();
  
    const interval = setInterval(() => {
      const agora = new Date().getTime();
      const diferenca = targetDate - agora;
  
      if (diferenca <= 0) {
        clearInterval(interval);
  
        // Se estava contando para "em breve", muda para contar até dataFim
        if (statusAtual === "em breve") {
          statusAtual = "aberto";
          targetDate = new Date(evento.dataFim).getTime();
          calcularTempoRestante({ ...evento, status: "aberto" });
        } else {
          setTempoRestante({ dias: 0, horas: 0, minutos: 0, segundos: 0 });
        }
  
        return;
      }
  
      const dias = Math.floor(diferenca / (1000 * 60 * 60 * 24));
      const horas = Math.floor((diferenca % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutos = Math.floor((diferenca % (1000 * 60 * 60)) / (1000 * 60));
      const segundos = Math.floor((diferenca % (1000 * 60)) / 1000);
  
      setTempoRestante({ dias, horas, minutos, segundos });
    }, 1000);
  
    return () => clearInterval(interval);
  };
  

  if (loading) {
    return (
      <div className="loading-container23">
        <div className="loading-spinner23"></div>
        <p>Carregando evento...</p>
      </div>
    )
  }

  if (!evento) {
    return (
      <div className="error-container23">
        <p>Evento não encontrado ou ocorreu um erro ao carregar.</p>
        <button onClick={() => navigate("/")} className="btn-voltar23">
          Voltar para a página inicial
        </button>
      </div>
    )
  }

  const handleComprarSenha = () => {
    const token = localStorage.getItem("token")
    if (!token) {
      navigate("/login", { state: { from: `/evento/${id}` } })
    } else {
      navigate("/compra-passo-1", { state: { evento } })
    }
  }

  return (
    <div className="evento-detalhes-container23">
      {/* Hero Section com Banner e Informações Principais */}
      <div className="evento-hero23">
        <div className="evento-hero-overlay23"></div>
        <div className="evento-hero-content23">
          <motion.h1
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="evento-titulo23"
          >
            {evento.nome}
          </motion.h1>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="evento-premiacao-badge23"
          >
            <Trophy className="icon-premiacao23" />
            <span>Premiação: </span>
            <strong>{Number(evento.premiacao).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</strong>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            className="evento-countdown-container23"
          >
            <div className="countdown-header23">
              <Clock className="icon-clock23" />
              <span>
                {evento.status === "em breve" ? "Início das Vendas em:" : "Encerramento das Vendas:"}
              </span>

            </div>

            <div className="countdown-timer23">
              <div className="countdown-item23">
                <div className="countdown-value23">{String(tempoRestante.dias).padStart(2, "0")}</div>
                <div className="countdown-label23">dias</div>
              </div>
              <div className="countdown-separator23">:</div>
              <div className="countdown-item23">
                <div className="countdown-value23">{String(tempoRestante.horas).padStart(2, "0")}</div>
                <div className="countdown-label23">horas</div>
              </div>
              <div className="countdown-separator23">:</div>
              <div className="countdown-item23">
                <div className="countdown-value23">{String(tempoRestante.minutos).padStart(2, "0")}</div>
                <div className="countdown-label23">min</div>
              </div>
              <div className="countdown-separator23">:</div>
              <div className="countdown-item23">
                <div className="countdown-value23">{String(tempoRestante.segundos).padStart(2, "0")}</div>
                <div className="countdown-label23">seg</div>
              </div>
            </div>
          </motion.div>

          <motion.button
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.6 }}
            className={`btn-comprar-hero23 ${evento.status === "em breve" ? "btn-desativado23" : ""}`}
            onClick={evento.status === "aberto" ? handleComprarSenha : undefined}
            disabled={evento.status !== "aberto"}
          >
            <ShoppingCart className="icon-cart23" />
            {evento.status === "em breve" ? "Vendas em breve" : "Comprar Senha Agora"}
          </motion.button>

        </div>
      </div>

      {/* Conteúdo Principal - 3 Colunas */}
      <div className="evento-content23 three-column-layout23">
        {/* Coluna 1: Sobre o Evento */}
        <div className="evento-column23">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.1 }}
            className="evento-card23"
            style={{ marginTop: "1.5rem" }}
          >
            <h2 className="card-title23">
              <Eye className="card-icon23" />
              Cartaz do Evento
            </h2>
            <div className="card-content23">
              <div className="cartaz-wrapper23" onClick={() => setShowModal(true)}>
                <img
                  src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`}
                  alt="Cartaz do Evento"
                  className="cartaz-thumbnail23"
                />
                <div className="cartaz-overlay23">
                  <Eye className="icon-view23" />
                  <span>Ampliar</span>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
        

        {/* Coluna 2: Cartaz do Evento */}
        <div className="evento-column23">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="evento-card23"
            style={{ marginTop: "1.5rem" }}
          >
            <h2 className="card-title23">
              <Calendar className="card-icon23" />
              Ordem da Corrida
            </h2>
            <div className="card-content23 ordem-content23" dangerouslySetInnerHTML={{ __html: evento.ordem }} />
          </motion.div>
        </div>

        {/* Coluna 3: Informações e Categorias */}
        <div className="evento-column23">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            className="evento-card23"
            style={{ marginTop: "1.5rem" }}
          >
            <h2 className="card-title23">
              <MapPin className="card-icon23" />
              Categorias
            </h2>
            <div className="card-content23">
              <div className="categoria-selector23">
                <label htmlFor="categoria-select23">Selecione uma categoria:</label>
                <select
                  id="categoria-select23"
                  onChange={(e) =>
                    setCategoriaSelecionada(evento.categorias.find((cat) => cat.nome === e.target.value))
                  }
                  value={categoriaSelecionada?.nome || ""}
                >
                  {evento.categorias.map((categoria, index) => (
                    <option key={index} value={categoria.nome}>
                      {categoria.nome}
                    </option>
                  ))}
                </select>
              </div>

              {categoriaSelecionada && (
                <div className="categoria-detalhes23">
                  <div className="categoria-header23">
                    <h3>{categoriaSelecionada.nome}</h3>
                    <button className="btn-mapa23" onClick={() => setShowMapaCategoria(true)}>
                      <MapPin className="icon-map23" />
                      Mapa da Categoria
                    </button>
                  </div>

                  <div className="senhas-grid23">
                    {categoriaSelecionada.senhas.map((senha, index) => {
                      const temPromo = senha.precoNoDia && Number(senha.precoNoDia) > Number(senha.preco)
                      return (
                        <motion.div
                          key={index}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3, delay: index * 0.1 }}
                          className={`senha-card23 ${temPromo ? "tem-promo23" : ""}`}
                        >
                          <div className="senha-header23">
                            <span className="senha-numero23">{senha.numero}ª</span>
                            <h4>Senha</h4>
                            {temPromo && <span className="promo-flag23">Antecipado</span>}
                          </div>

                          <div className="senha-preco23">
                            {temPromo && (
                              <span className="preco-no-dia23">
                                No dia {Number(senha.precoNoDia).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                              </span>
                            )}
                            <span className="preco-valor23">
                              {Number(senha.preco).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                            </span>
                          </div>

                          <div className="senha-taxas23">
                            {(evento.taxasObrigatorias || []).map((taxa, i) => (
                              <div className="taxa-item23" key={i}>
                                <span className="taxa-label23">{taxa.nome}</span>
                                <span className="taxa-valor23">
                                  {Number(taxa.valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                </span>
                              </div>
                            ))}

                            <div className="taxa-item23">
                              <span className="taxa-label23">Boi TV</span>
                              <span className={`taxa-valor23 ${Number(senha.boiTv) === 0 ? "gratis23" : ""}`}>
                                {Number(senha.boiTv) === 0
                                  ? "Grátis"
                                  : Number(senha.boiTv).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                              </span>
                            </div>

                            {categoriaSelecionada?.taxaOpcional?.nome && (
                              <div className="taxa-item23">
                                <span className="taxa-label23">{categoriaSelecionada.taxaOpcional.nome}</span>
                                <span className="taxa-valor23">
                                  {Number(categoriaSelecionada.taxaOpcional.valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                </span>
                              </div>
                            )}
                          </div>
                        </motion.div>
                      )
                    })}
                  </div>

                  <motion.button
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.4 }}
                    onClick={() => {
                      if (evento.status === "aberto") {
                        navigate("/compra-passo-1", {
                          state: { evento, categoria: categoriaSelecionada }
                        });
                      }
                    }}
                    disabled={evento.status !== "aberto"}
                    className={`btn-comprar-hero23 ${evento.status !== "aberto" ? "btn-desativado23" : ""}`}
                  >
                    <ShoppingCart className="icon-cart23" />
                    {evento.status === "em breve" ? "Em breve" : "Comprar Senha"}
                  </motion.button>




                </div>
              )}
            </div>
          </motion.div>
        </div>
      </div>

      {/* Modal para Cartaz Ampliado */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="modal-overlay23"
            onClick={() => setShowModal(false)}
          >
            <motion.div
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.8 }}
              className="modal-content23"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="btn-fechar23" onClick={() => setShowModal(false)}>
                <X className="icon-close23" />
              </button>
              <img
                src={`https://api.ticketdovaqueiro.com/uploads/${evento.imagem}`}
                alt="Cartaz Ampliado"
                className="cartaz-ampliado23"
              />
            </motion.div>
          </motion.div>
        )}
        
      </AnimatePresence>
      <AnimatePresence>
      {showMapaCategoria && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="modal-overlay59"
          onClick={() => setShowMapaCategoria(false)}
        >
          <motion.div
            initial={{ scale: 0.8 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.8 }}
            className="modal-content59"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "95vw", maxHeight: "95vh", overflowY: "auto" }}
          >
            <button className="btn-fechar59" onClick={() => setShowMapaCategoria(false)}>
              <X className="icon-close59" />
            </button>
            <MapaCategoriaVisual
              evento={evento}
              categoriaSelecionada={categoriaSelecionada?.nome || ""}
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>

    </div>
  )
}

export default DetalhesEvento